import axios from "axios";

// create axios instance with baseURL and x-Api-key
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL_LOGIN_APP,
  withCredentials: true, // This ensures cookies are sent with every request
  headers: {
    // "Access-Control-Allow-Origin": `${process.env.REACT_APP_BACKEND_URL_LOGIN_APP}`,
    // "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    "Content-Type": "application/json",
    // "Access-Control-Allow-Credentials": "true",
  },
  credentials: true,
});

// *************** Add a request interceptor *********************

axiosInstance.interceptors.request.use(
  (config) => {
    config.withCredentials = true; // Ensure credentials (cookies) are included
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let count = 1;

// **************function for get request********************
export const getRequest = async (url, params) => {
  try {
    const res = await axiosInstance.get(url, { params });
    // console.log(`Response from getRequest : ${count++} `, res);
    return res;
  } catch (error) {
    return error?.response;
  }
};


// function for post request
export const postRequest = async (url, data) => {
  try {
    const res = await axiosInstance.post(url, data, {
      withCredentials: true,
    });
    return res;
  } catch (error) {
    return error?.response;
  }
};

// function for patch request
export const patchRequest = async (url, data) => {
  try {
    const res = await axiosInstance.patch(url, data);
    return res;
  } catch (error) {
    return error?.response;
  }
};

// function for put request
// export const putRequest = async (url, data) => {
//   try {
//     const res = await axiosInstance.put(url, data)
//     return res
//   } catch (error) {
//     return error?.response
//   }
// }

// function for delete request
export const deleteRequest = async (url, id) => {
  try {
    const res = await axiosInstance.delete(url, {
      data: { id }, // DELETE requests expect `data` property for body
      headers: {
        "Content-Type": "application/json", // Correct Content-Type for JSON
      },
      withCredentials: true,
    });
    return res;
  } catch (error) {
    return error.response ? error.response.data : error.message;
  }
};

// Function to handle POST requests with FormData
export const postFormDataRequest = async (url, formData) => {
  try {
    const res = await axiosInstance.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Important: Content-Type for FormData
      },
    });
    return res;
  } catch (error) {
    return error?.response;
  }
};

export const putRequest = async (url, formData) => {
  try {
    const res = await axiosInstance.put(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Important: Content-Type for FormData
      },
    });
    return res;
  } catch (error) {
    return error?.response;
  }
};

export const putRequest2 = async (url, formData) => {
  try {
    const res = await axiosInstance.put(url, formData, {
      headers: {
        "Content-Type": "application/json", // Important: Content-Type for FormData
      },
    });
    return res;
  } catch (error) {
    return error?.response;
  }
};

export { axiosInstance };
